export function mostrarLoader(vistaSimplificada = false) {
  if (!document.getElementById("initial-loader")) {
    const divloader = document.createElement('div');
    divloader.id = 'initial-loader';
    divloader.className = 'initial-loader';

    

    let contenidoLoader;

    if (vistaSimplificada) {
      contenidoLoader = document.createElement('p');
      contenidoLoader.innerHTML = 'Cargando...';
    } else {
      contenidoLoader = document.createElement('img');
      contenidoLoader.src = 'loader/loader.svg';
    }

    divloader.appendChild(contenidoLoader);
    document.getElementsByTagName('body')[0].appendChild(divloader).style.overflow = 'hidden';
  }
  else{
    document.getElementsByTagName('body')[0].style.overflow = 'hidden';
  }

  document.getElementById("initial-loader").style.display = "flex"
}

export function quitarLoader() {
  if (document.getElementById("initial-loader")) {
    document.getElementById("initial-loader").style.display = "none"
    document.getElementsByTagName('body')[0].style.overflow = 'visible';
  }
}

export function scrollTo(element, top = -80) {
  window.scroll({
    behavior: 'smooth',
    left: 0,
    top: element.offsetTop + top
  });
}

export function scrollToFichas(element) {
  scrollTo(element, 800);
}